import styled from 'styled-components'
import { backgroundOrange, darkOrange, textMuted, mutedGrey, warmTint } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

export const Breadcrumb = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    font-size: ${fontSizes.caption};
    color: ${textMuted};
`

export const BreadcrumbStep = styled.button<{ $current?: boolean }>`
    background: ${({ $current }) => ($current ? backgroundOrange : 'transparent')};
    border: 1px solid ${({ $current }) => ($current ? warmTint : 'transparent')};
    border-radius: ${radii.small};
    padding: 4px 8px;
    font-size: ${fontSizes.caption};
    color: ${({ $current }) => ($current ? darkOrange : textMuted)};
    cursor: ${({ $current }) => ($current ? 'default' : 'pointer')};

    &:hover:not(:disabled) {
        text-decoration: ${({ $current }) => ($current ? 'none' : 'underline')};
    }
`

export const BreadcrumbSeparator = styled.span`
    color: ${mutedGrey};
`
